import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import { injectStripe } from 'react-stripe-elements'
import visaIcon from 'payment-icons/min/flat/visa.svg'
import mastercardIcon from 'payment-icons/min/flat/mastercard.svg'
import amexIcon from 'payment-icons/min/flat/amex.svg'
import unionpayIcon from 'payment-icons/min/flat/unionpay.svg'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import creditCardIcon from '../../assets/images/payment/credit-card.png'
import { ADD_CREDIT_CARD, addCreditCard } from '../../actions/user'
import { addError } from '../../actions/notifications'
import { reset } from '../../actions/selector'
import StyleButton from '../../components/StyleButton'
import { createLoadingSelector, createSuccessSelector } from '../../reducers/selector'
import CardInput from '../../components/CardInput'
import PopupModal from '../../components/PopupModal'
import tickIcon from '../../assets/images/common/tick.png'

const paymentIcon = {
  VISA: visaIcon,
  UNIONPAY: unionpayIcon,
  'AMERICAN EXPRESS': amexIcon,
  MASTERCARD: mastercardIcon,
}

const styles = () => {
  return {
    '@global': {
      '.StripeElement': {
        backgroundColor: 'white',
        padding: '10px 12px',
        borderRadius: '20px',
        border: '1px solid transparent',
        boxShadow: '0 3px 3px #D2D2D2',
        WebkitTransition: 'box-shadow 150ms ease',
        transition: 'box-shadow 150ms ease',
      },
      '.StripeElement__focus': {
        boxShadow: '0 1px 3px 0 #cfd7df',
      },
      '.StripeElement__invalid': {
        borderColor: '#fa755a',
      },
      '.StripeElement__webkit_autofill': {
        backgroundColor: '#fefde5 !important',
      },
    },
    formRow: {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    popupModalButtonContainer: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    popupModalButton: {
      marginBottom: '5px',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    isFetching: createLoadingSelector([ADD_CREDIT_CARD])(state),
    isSuccess: createSuccessSelector([ADD_CREDIT_CARD])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addCreditCard(cardToken) {
      return dispatch(addCreditCard(cardToken))
    },
    addError(error) {
      return dispatch(addError(error))
    },
    reset(type) {
      return dispatch(reset(type))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
@injectStripe
class AddCreditCardPage extends Component {
  state = {
    cardBrand: 'unknown',
    displayAddCreditSuccessPopup: false,
  }

  componentDidMount() {
    this.props.reset(ADD_CREDIT_CARD)
  }

  handleSubmitButtonClick = async () => {
    const { stripe } = this.props
    try {
      const res = await stripe.createToken()
      console.log(res)
      if (res.error) {
        throw new Error(res.error.message)
      }
      this.props.addCreditCard(res.token.id)
    } catch (err) {
      this.props.addError(err.message)
      console.error(err)
    }
  }

  handleCardNumberChange = (event) => {
    if (event.brand) {
      this.setState({
        cardBrand: event.brand.toUpperCase(),
      })
    }
  }

  handleDisplaySuccessPopupDismiss = () => {
    this.setState({
      displayAddCreditSuccessPopup: false,
    })
  }

  handlePopupButtonClick = () => {
    const { history } = this.props
    this.setState({
      displayAddCreditSuccessPopup: false,
    })
    history.goBack()
  }

  static getDerivedStateFromProps(props, state) {
    if (state.displayAddCreditSuccessPopup !== props.isSuccess) {
      return {
        displayAddCreditSuccessPopup: props.isSuccess,
      }
    }
    return null
  }

  render() {
    const { cardBrand, displayAddCreditSuccessPopup } = this.state
    const {
      classes, isFetching, isSuccess, t,
    } = this.props
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('new_credit_card')} />
        {displayAddCreditSuccessPopup && (
          <PopupModal
            title={t('success')}
            icon={tickIcon}
            onDismiss={this.handleDisplaySuccessPopupDismiss}
          >
            <p>{`${t('new_credit_card')} ${t('success')}`}</p>
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('ok')}
                  styleType={'secondary'}
                  onClick={this.handlePopupButtonClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        <MobileContent>
          <div>
            <WhiteBox
              title={'xxxx-xxxx-xxxx-xxxx'}
              description={cardBrand}
              image={
                Object.prototype.hasOwnProperty.call(paymentIcon, cardBrand)
                  ? paymentIcon[cardBrand]
                  : creditCardIcon
              }
            />
            <CardInput onCardNumberChange={this.handleCardNumberChange} />
            <div className={classes.paymentButton}>
              <StyleButton
                name={t('confirm')}
                onClick={this.handleSubmitButtonClick}
                styleType={'secondary'}
                disabled={isFetching || isSuccess}
              />
            </div>
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

AddCreditCardPage.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object,
  creditCards: PropTypes.array,
  stripe: PropTypes.object,
  addCreditCard: PropTypes.func,
  reset: PropTypes.func,
  addError: PropTypes.func,
  isFetching: PropTypes.bool,
  isSuccess: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func,
}

export default AddCreditCardPage
